import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const data = [
    {
        predName: '8 am',
        predUv: 4000,
        predPv: 2400,
        predAmt: 2400,
    },
    {
        predName: '10am',
        predUv: 3000,
        predPv: 1398,
        predAmt: 2210,
    },
    {
        predName: '12pm',
        predUv: 2000,
        predPv: 9800,
        predAmt: 2290,
    },
    {
        predName: '2pm',
        predUv: 2780,
        predPv: 3908,
        predAmt: 2000,
    },
    {
        predName: '4pm',
        predUv: 1890,
        predPv: 4800,
        predAmt: 2181,
    },
    {
        predName: '6pm',
        predUv: 2390,
        predPv: 3800,
        predAmt: 2500,
    },
    {
        predName: '8pm',
        predUv: 3490,
        predPv: 4300,
        predAmt: 2100,
    },
    {
        predName: '10pm',
        predUv: 2499,
        predPv: 3000,
        predAmt: 2872,
    },
];

const PredictedSaleBarChart = () => {

    return (
        <ResponsiveContainer width="100%" height="100%">
            <BarChart
                width={500}
                height={235}
                data={data}
                margin={{
                    top: 0,
                    right: 0,
                    left: 0,
                    bottom: 0,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="predName" fontSize={12} />
                <YAxis />
                <Tooltip />
                {/* <Legend /> */}
                <Bar dataKey="predPv" fill="#8D23DD" radius={[10, 10, 0, 0]} />
                <Bar dataKey="predUv" fill="#66CB9F" radius={[10, 10, 0, 0]} />
            </BarChart>
        </ResponsiveContainer>
    );
}

export default PredictedSaleBarChart;
